<template>
  <tooltip class="product-selector">
    <template #trigger="{ toggle }" @hide="$emit('hide')" @show="$emit('show')">
      <div
        class="product-dropdown-trigger flex items-center bg-white"
        @click="toggle"
      >
        <svg width="20" height="20" class="mr-2" fill="currentColor">
          <use :xlink:href="selectedItem.icon"></use>
        </svg>

        <div class="text flex-1">{{ selectedItem.title }}</div>

        <svg width="20" height="20" fill="currentColor">
          <use xlink:href="/img/sprite.svg#ic_chevron-down"></use>
        </svg>
      </div>
    </template>

    <template #default="{ hide }">
      <ul class="list-reset bg-white px-4 w-full mdsm:mt-1 mdsm:py-2 rounded-b">
        <li
          class="flex items-start py-4 mb-0"
          v-for="item in availableProducts"
          :key="item.value"
          @click="onSelect(item.value, hide)"
        >
          <div
            class="icon flex items-center justify-center text-secondary mr-2"
          >
            <svg width="20" height="20" fill="currentColor">
              <use :xlink:href="item.icon"></use>
            </svg>
          </div>
          <div class="text">
            <div class="leading-6">{{ item.title }}</div>
          </div>
        </li>
      </ul>
    </template>
  </tooltip>
</template>

<script>
import Tooltip from "../../core/Tooltip";

export default {
  components: {
    Tooltip,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selected: this.value,
      options: [
        {
          title: "Resorts",
          subTitle: "Stay and dive from a land-based resort",
          icon: "/img/sprite.svg#ic_resort",
          value: "resort",
        },
        {
          title: "Liveaboards",
          subTitle: "Cruise and dive the best spots in the region",
          icon: "/img/sprite.svg#ic_boat",
          value: "liveaboard",
        },
        {
          title: "Charter Yachts",
          subTitle: "Book a private boat expedition",
          icon: "/img/sprite.svg#ic_charter-yacht",
          value: "yacht",
        },
      ],
    };
  },
  computed: {
    selectedItem() {
      return this.options.find((o) => o.value === this.selected);
    },
    availableProducts() {
      if (!this.checkAvailability) {
        return this.options;
      } else {
        if (this.productAvailability === null) {
          return this.options;
        } else {
          let productList = this.options;

          if (this.productAvailability.hasResorts === false) {
            productList = productList.filter((p) => {
              return p.value !== "resort";
            });
          }

          if (this.productAvailability.hasLiveaboards === false) {
            productList = productList.filter((p) => {
              return p.value !== "liveaboard";
            });
          }

          if (this.productAvailability.hasEcoventures === false) {
            productList = productList.filter((p) => {
              return p.value !== "ecoventure";
            });
          }

          if (this.productAvailability.hasYachts === false) {
            productList = productList.filter((p) => {
              return p.value !== "yacht";
            });
          }

          if (productList.length === 0) {
            productList = this.options.filter((opt) => {
              return opt.value === window.zubluSearchType;
            });
          }

          return productList;
        }
      }
    },
  },
  methods: {
    onSelect(val, hide) {
      this.selected = val;
      this.$emit("input", val);

      hide();
    },
  },
};
</script>

<style scoped>
.product-dropdown-trigger {
  height: 48px;
  padding: 0 1rem;
}

.list-reset {
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
}
</style>
